import React from 'react';
import { BoltIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/constants';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-petrol-dark px-4 py-9 sm:px-6 sm:py-12" data-id="element-65" data-mp="c8c0v7sdwjem">
      <div className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="84xiiagz3qy0">
        <p className="inline-block rounded-full bg-gold px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.16em] text-petrol-dark sm:text-xs" data-id="element-67" data-mp="87jsegrc6ije">
          Offre à durée limitée
        </p>
        <h2 className="mt-2.5 text-xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-68" data-mp="vurw4u949jjb">
          Complétez votre système professionnel aujourd’hui
        </h2>
        <div className="mt-3" data-id="element-69" data-mp="qw6sekunohq4">
          <Countdown data-id="element-70" data-mp="14vfyust27xgw" />
        </div>

        <div className="mt-5 rounded-2xl border border-white/15 bg-white/5 p-4 sm:p-5" data-id="element-71" data-mp="14uoc87hfxa2r">
          <h3 className="text-base font-extrabold text-white sm:text-xl" data-id="element-72" data-mp="zwv7livsco4l">Orthophonie Pro™</h3>
          <p className="mt-0.5 text-[12px] text-cream/80 sm:text-sm" data-id="element-73" data-mp="2c56cy8srgdli">
            Système Professionnel 6-en-1 + 5 Bonus Stratégiques
          </p>
          <p className="mt-2 text-xs font-semibold text-cream/60 line-through" data-id="element-74" data-mp="2h3zuqdf2yqrh">
            Prix Régulier : 97 €
          </p>
          <p className="font-display text-3xl font-extrabold uppercase text-gold sm:text-4xl" data-id="element-75" data-mp="2r1xg8t5k29ge">
            Aujourd’hui : 27 €
          </p>
          <p className="mt-1.5 inline-block rounded-full bg-gold px-2.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-widest text-petrol-dark" data-id="element-76" data-mp="2v2hdrxu1jf32">
            Économisez 70 €
          </p>
          <CTAButton href={CHECKOUT_URL} variant="gold" className="mx-auto mt-4 max-w-lg" data-id="element-77" data-mp="34udd1c7v5b8v">
            Accédez à Orthophonie Pro™ maintenant
          </CTAButton>
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-cream/80" data-id="element-78" data-mp="3errrx7e51rz2">
            <li className="flex items-center gap-1.5" data-id="element-79" data-mp="3iu4vpq9brft7">
              <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-80" data-mp="1jocxmctvixw0" /> Paiement Sécurisé
            </li>
            <li className="flex items-center gap-1.5" data-id="element-81" data-mp="1epiiplz11th6">
              <BoltIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-82" data-mp="1er3d9blcdcf1" /> Accès Numérique
              Immédiat
            </li>
            <li className="flex items-center gap-1.5" data-id="element-83" data-mp="1npyjuosasoiv">
              <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-84" data-mp="1nodpaz5zh5l0" /> Garantie 7
              Jours
            </li>
          </ul>
        </div>
      </div>
    </section>;
}